<div class="basket-desired-delivery-date">
  <div class="sectionnew">
    <form [formGroup]="form" (ngSubmit)="submitForm()">
      <div class="row">
        @if (showSuccessMessage) {
        <div class="col-md-12">
          <ish-success-message message="checkout.desired_delivery_date.success.message" [toast]="false" />
        </div>
        }

        <div class="col-md-8">
          <formly-form [form]="form" [fields]="fields" [model]="model" />
        </div>

        <div class="col-md-4 pl-md-0">
          <button type="submit" class="btn btn-secondary custom-apply-btn" [disabled]="disabled">
            {{ 'checkout.desired_delivery_date.apply.button.label' | translate }}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
